import Vue from 'vue';
import VueRouter from 'vue-router';
Vue.use(VueRouter);
const routes = [
  {
    path: '/login',
    name: 'login',
    meta: {
      title: '登录'
    },
    component: function() {
      return import(/* webpackChunkName: "login" */ '../views/user/login');
    }
  },
  {
    path: '/loginPwd',
    name: 'loginPwd',
    component: function() {
      return import(/* webpackChunkName: "loginPwd" */ '../views/user/loginPwd');
    }
  },
  {
    path: '/loginCaptcha',
    name: 'loginCaptcha',
    component: function() {
      return import(/* webpackChunkName: "loginCaptcha" */ '../views/user/loginCaptcha');
    }
  },
  {
    path: '/register',
    name: 'register',
    meta: {
      title: '注册'
    },
    component: function() {
      return import(/* webpackChunkName: "register" */ '../views/user/register');
    }
  },
  {
    path: '/rePwd',
    name: 'rePwd',
    meta: {
      title: '重置密码'
    },
    component: function() {
      return import(/* webpackChunkName: "rePwd" */ '../views/user/rePwd');
    }
  },

  {
    path: '/join',
    name: 'join',
    meta: {
      title: '分站开通'
    },
    component: function() {
      return import(/* webpackChunkName: "join" */ '../views/join');
    }
  },
  {
    path: '/invite',
    name: 'invite',
    meta: {
      title: '邀请好友'
    },
    component: function() {
      return import(/* webpackChunkName: "invite" */ '../views/invite');
    }
  },
  {
    path: '/post',
    name: 'post',
    meta: {
      title: '邀请海报'
    },
    component: function() {
      return import(/* webpackChunkName: "invite" */ '../views/post');
    }
  },
  {
    path: '/extensions',
    name: 'extensions',
    meta: {
      title: '邀请奖励'
    },
    component: function() {
      return import(/* webpackChunkName: "extensions" */ '../views/my/extensions');
    }
  },
  {
    path: '/withdraw',
    name: 'withdraw',
    meta: {
      title: '提现'
    },
    component: function() {
      return import(/* webpackChunkName: "withdraw" */ '../views/my/withdraw');
    }
  },
  {
    path: '/rechrage',
    name: 'rechrage',
    meta: {
      title: '充值'
    },
    component: function() {
      return import(/* webpackChunkName: "rechrage" */ '../views/my/rechrage');
    }
  },
  {
    path: '/forward',
    name: 'forward',
    meta: {
      title: '代发指南'
    },
    component: function() {
      return import(/* webpackChunkName: "forward" */ '../views/forward');
    }
  },
  {
    path: '/goods',
    name: 'goods',
    meta: {
      title: '商品列表'
    },
    component: function() {
      return import(/* webpackChunkName: "goods" */ '../views/good/goods');
    }
  },
  {
    path: '/goodDetail',
    name: 'goodDetail',
    meta: {
      title: '商品详情'
    },
    component: function() {
      return import(/* webpackChunkName: "goodDetail" */ '../views/good/good_detail');
    }
  },
  {
    path: '/address',
    name: 'address',
    meta: {
      title: '录入收件信息'
    },
    component: function() {
      return import(/* webpackChunkName: "address" */ '../views/good/address');
    }
  },

  {
    path: '/addressEdit',
    name: 'addressEdit',
    meta: {
      title: '编辑收件信息'
    },
    component: function() {
      return import(/* webpackChunkName: "addressEdit" */ '../views/good/addressEdit');
    }
  },
  {
    path: '/storeList',
    name: 'storeList',
    meta: {
      title: '选择店铺'
    },
    component: function() {
      return import(/* webpackChunkName: "storeList" */ '../views/good/storeList');
    }
  },
  {
    path: '/tagList',
    name: 'tagList',
    meta: {
      title: '标记筛选'
    },
    component: function() {
      return import(/* webpackChunkName: "tagList" */ '../views/good/tagList');
    }
  },

  {
    path: '/addrssFilter',
    name: 'addrssFilter',
    meta: {
      title: '订单筛选'
    },
    component: function() {
      return import(/* webpackChunkName: "addrssFilter" */ '../views/good/addrssFilter');
    }
  },
  {
    path: '/orderConfirm',
    name: 'orderConfirm',
    meta: {
      title: '确认订单'
    },
    component: function() {
      return import(/* webpackChunkName: "orderConfirm" */ '../views/order/confirm');
    }
  },
  {
    path: '/payResult',
    name: 'payResult',

    component: function() {
      return import(/* webpackChunkName: "orderConfirm" */ '../views/order/payResult');
    }
  },
  {
    path: '/orderDetail',
    name: 'orderDetail',
    meta: {
      title: '订单详情'
    },
    component: function() {
      return import(/* webpackChunkName: "orderDetail" */ '../views/order/detail');
    }
  },

  {
    path: '/orderPay',
    name: 'orderPay',

    component: function() {
      return import(/* webpackChunkName: "orderPay" */ '../views/order/pay');
    }
  },
  {
    path: '/',
    component: function() {
      return import(/* webpackChunkName: "layout" */ '../views/layout');
    },
    children: [
      {
        path: '', //首页是默认子路由，所谓为空
        name: 'home',
        component: function() {
          return import(/* webpackChunkName: "home" */ '../views/Home');
        }
      },

      {
        path: '/buy',
        name: 'buy',
        meta: {
          title: '立即下单'
        },
        component: function() {
          return import(/* webpackChunkName: "buy" */ '../views/good/buy');
        }
      },
      {
        path: '/order',
        name: 'order',
        meta: {
          title: '订单'
        },
        component: function() {
          return import(/* webpackChunkName: "order" */ '../views/order/list');
        }
      },
      {
        path: '/user',
        name: 'user',
        meta: {
          title: '我的'
        },
        component: function() {
          return import(/* webpackChunkName: "my" */ '../views/my/user');
        }
      }
    ]
  },
  {
    path: '/baseSetting',
    name: 'baseSetting',
    meta: {
      title: '个人设置'
    },
    component: function() {
      return import(/* baseSetting: "baseSetting" */ '../views/my/baseSetting');
    }
  },
  {
    path: '/safeSetting',
    name: 'safeSetting',
    meta: {
      title: '安全中心'
    },
    component: function() {
      return import(/* baseSetting: "safeSetting" */ '../views/my/safeSetting');
    }
  },
  {
    path: '/password',
    name: 'password',
    component: function() {
      return import(/* baseSetting: "password" */ '../views/my/password');
    }
  },
  {
    path: '/vertify',
    name: 'vertify',
    meta: {
      title: '实名认证'
    },
    component: function() {
      return import(/* baseSetting: "password" */ '../views/my/vertify');
    }
  },
  {
    path: '/mobile',
    name: 'mobile',
    component: function() {
      return import(/* baseSetting: "mobile" */ '../views/my/mobile');
    }
  },
  {
    path: '/alipayAccount',
    name: 'alipayAccount',
    component: function() {
      return import(/* baseSetting: "alipayAccount" */ '../views/my/alipayAccount');
    }
  },
  {
    path: '/balance',
    name: 'balance',
    meta: {
      title: '余额明细'
    },
    component: function() {
      return import(/* webpackChunkName: "balance" */ '../views/balance');
    }
  },
  {
    path: '/storeBind',
    name: 'storeBind',
    meta: {
      title: '店铺绑定'
    },
    component: function() {
      return import(/* webpackChunkName: "storeBind" */ '../views/my/storeBind');
    }
  },
  {
    path: '/taobao',
    name: 'taobao',
    component: function() {
      return import(/* webpackChunkName: "taobao" */ '../views/taobao');
    }
  },
  {
    path: '/fwtaobao',
    name: 'fwtaobao',
    component: function() {
      return import(/* webpackChunkName: "fwtaobao" */ '../views/fwtaobao');
    }
  },
  {
    path: '/alibaba',
    name: 'alibaba',
    component: function() {
      return import(/* webpackChunkName: "alibaba" */ '../views/alibaba');
    }
  },
  {
    path: '/pdd',
    name: 'pdd',
    component: function() {
      return import(/* webpackChunkName: "pdd" */ '../views/pdd');
    }
  },
  {
    path: '/douyin',
    name: 'douyin',
    component: function() {
      return import(/* webpackChunkName: "douyin" */ '../views/douyin');
    }
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});
//路由重定向时报错
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch((err) => err);
};
export default router;
